import { render } from "./ItemAlunoPesquisa.vue?vue&type=template&id=14ec823c"
import script from "./ItemAlunoPesquisa.vue?vue&type=script&lang=js"
export * from "./ItemAlunoPesquisa.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__